import 'date-fns';
import React, { useState, useRef, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

// radio buttons
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';

import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import validator from 'validator';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Button from '@material-ui/core/Button';
import PrintIcon from '@material-ui/icons/Print';
import SendIcon from '@material-ui/icons/Send';
import { formSubmitAction } from './form-submit-action';
import SubmitFormDialog from './submit-form-dialog';
import UploadFileDialog from './upload-file-dialog';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';

import { useStyles } from './styles';

function GuarantorForm (props) {

    const isDialogProps = {
        isOpen: false,
        agentName: '',
        msg: '',
        handleClose: '',
    }

    const isUploadDialogProps = {
        isOpen: false,
        uploadLink: '',
        handleUploadClose: '',
    }

    const fileValObj = {
        guarantorIdentityUpload: '',
        guarantorUtilityUpload: '',
    }

    const btnChecksObj = {
        isTermsAgree: false,
        isCovenantAgree: false,
        guarantorIdentityUpload: false,
        guarantorUtilityUpload: false,
    }

    const [fileVal, setFileVal] = useState(fileValObj);
    const [userDocs, setUserDocs] = useState({pictures: []});
    const [dialogProps, setDialogProps] = useState(isDialogProps);
    const [isTermsAgree, setIsTermsAgree] = useState(false);
    const [isCovenantAgree, setIsCovenantAgree] = useState(false);
    const [uploadDialogProps, setUploadDialogProps] = useState(isUploadDialogProps);
    const [isSubmitBtn, setIsSubmitBtn] = useState(false);
    const [isBtnChecks, setIsBtnChecks] = useState(btnChecksObj);

    // const [selectedDate, setSelectedDate] = React.useState(new Date());

    const utilityFileRef = useRef(null);
    const identityFileRef = useRef(null);
    const idDisplayRef = useRef(null);
    const utilDisplayRef = useRef(null);
    const termsAgreeRef = useRef(null);
    const covenantAgreeRef = useRef(null);
    const formTagRef = useRef(null);

    

    const handleFileChange = (e) => {
        setFileVal(prevState => {
            return {
                ...prevState,
                [e.target.name]: e.target.files[0],
            }
        })
        setUserDocs({
            pictures: userDocs['pictures'].concat({
                fieldName: e.target.name,
                fileObj: e.target.files[0]
            })
        })

        if((e.target.name == 'guarantorIdentityUpload')) {

            var idInput = e.target;

            var reader = new FileReader();
            reader.onload = () => {
                var dataSrc = reader.result;
                var output = idDisplayRef.current;
                output.src = dataSrc;
            }
            reader.readAsDataURL(idInput.files[0]);
            setIsBtnChecks({...isBtnChecks, guarantorIdentityUpload: true});

        }else if((e.target.name == 'guarantorUtilityUpload')) {

            var utilInput = e.target;

            var reader = new FileReader();
            reader.onload = () => {
                var dataSrc = reader.result;
                var output = utilDisplayRef.current;
                output.src = dataSrc;
            }
            reader.readAsDataURL(utilInput.files[0]);
            setIsBtnChecks({...isBtnChecks, guarantorUtilityUpload: true});
        }else {
            setIsBtnChecks({...isBtnChecks, guarantorIdentityUpload: false});
            setIsBtnChecks({...isBtnChecks, guarantorUtilityUpload: false});
        }
    }

    const handleCheckbox = (e) => {

        if(e.target.name === 'termsAgree') {

            setIsTermsAgree(prevState => {
                setIsBtnChecks({...isBtnChecks, isTermsAgree: !prevState});
                return !prevState
            });
        }else if (e.target.name === 'covenantAgree') {

            setIsCovenantAgree(prevState => {
                setIsBtnChecks({...isBtnChecks, isCovenantAgree: !prevState});
                return !prevState
            });
        }
        

        
    }

    const handleClose = () => {
        setDialogProps(prevState => {

            return {
                ...prevState,
                isOpen: false,
            }
        });
    };

    // const submitResponse = formSubmitAction(formDataObj);
    // submitResponse.then(res => console.log(res));

    const classes = useStyles();

    const formik = useFormik({

        initialValues: {
            agentFullname: '',
            pocketmoniAcct: '',
            firstname: '',
            lastname: '',
            email: '',
            phoneno: '',
            homeAddress: '',
            outstandingLoanInput: '',
            relationship: '',
            businessName: '',
            businessAddress: '',
            jobTitle: '',
            companyName: '',
            companyAddress: '',
            footerGuarantorName: '',
            footerGuarantorSign: '',
            covenantFullname: '',
            title: '',
            gender: '',
            employment: '',
            businessActivity: '',
            covenantAgree: 'yes',
            termsAgree: '',
            applicationDate: Date.now(),
        },
        validationSchema: Yup.object({

            email: Yup.string()
            .email('Invalid email address'),

            phoneno: Yup.number()
            .min(1111111111, 'Phone number must not be less than 11 digits')
            .max(9999999999, 'Phone number must not be more than 11 digits'),

            pocketmoniAcct: Yup.number()
            .min(1111111111, 'Pocketmoni account must not be less than 11 digits')
            .max(9999999999, 'Pocketmoni account must not be more than 11 digits'),
        }),
        onSubmit: values => {

            if((isTermsAgree === false) && (isCovenantAgree === false)) {

                setDialogProps(prevState => {

                    return {
                        ...prevState,
                        isOpen: true,
                        names: '',
                        msg: '<span style="color: red;">Please accept the terms and conditions before continuing this process, thank you!<span>',
                        handleClose
                    }
                });
            }else if((isTermsAgree === true) && (isCovenantAgree === true)) {

                const params = {
                    isUrl: 'guarantor',
                    data: values,
                }
    
                setIsSubmitBtn(true)
                setDialogProps(prevState => {
    
                    return {
                        ...prevState,
                        isOpen: true,
                        names: '',
                        msg: '...Processing please wait!',
                        handleClose
                    }
                });
    
                const submitResponse = formSubmitAction(params);
                submitResponse.then(submit => {
    
                    if(submit.result == 'success') {
    
                        // const fileValues = Object.values(fileVal);
    
                        // fileValues.forEach(fileValue => {
    
                        //     const { name, type } = fileValue;
    
                        //     // format file name
                        //     const guarantorEmails = `${values.email}`;
                        //     const date = new Date();
                        //     // const fileDate = `${date.getDate()}-${date.getMonth()}-${date.getFullYear()}`;
                        //     const fileType = type;
                        //     const cleanFilename = `images/guarantors/${guarantorEmails.toLowerCase()}-${name.toLowerCase()}`;
                        //     const fileName = cleanFilename;
    
    
                        //     const generatePutUrl = `https://aws-file-uploader.herokuapp.com/generate-put-url`;
    
                        //     const options = {
    
                        //         params: {
                        //             Key: fileName,
                        //             ContentType: fileType
                        //         },
                        //         headers: {
                        //             "Content-Type": fileType
                        //         }
                        //     }
    
                            
                        //     axios.get(generatePutUrl, options)
                        //     .then(res => {
                        //         const { data } = res;
                        //         const putURL = data;
    
                        //         const guarantorURL = `https://aws-file-uploader.herokuapp.com/guarantor-uploads`;
    
                        //         const guarantorOptions = {
                        //             params: {
                        //                 file: fileValue,
                        //                 putURL,
                        //                 ContentType: fileType
                        //             },
                        //             headers: {
                        //                 "Content-Type": fileType
                        //             }
                        //         }
                            
                        //         axios.get(guarantorURL, guarantorOptions)
                        //         .then(res => {
                                    
                        //             setDialogProps(prevState => {
    
                        //                 return {
                        //                     ...prevState,
                        //                     isOpen: true,
                        //                     names: values.firstname+' '+values.lastname,
                        //                     msg: 'Thanks for submitting your application, we will attend to it and get back to you as soon as possible!',
                        //                     handleClose
                        //                 }
                        //             });
                        //             setIsSubmitBtn(false)
                        //         })
                        //         .catch(err => {
    
                        //             setDialogProps(prevState => {
    
                        //                 return {
                        //                     ...prevState,
                        //                     isOpen: true,
                        //                     names: values.firstname+' '+values.lastname,
                        //                     msg: 'Seems like something went wrong, pls try again!',
                        //                     handleClose
                        //                 }
                        //             });
                        //             setIsSubmitBtn(false)
                        //         })
                        //     })
                        //     .catch(err => {
    
                        //         setDialogProps(prevState => {
    
                        //             return {
                        //                 ...prevState,
                        //                 isOpen: true,
                        //                 names: values.firstname+' '+values.lastname,
                        //                 msg: 'Seems like something went wrong, pls try again!',
                        //                 handleClose
                        //             }
                        //         });
                        //         setIsSubmitBtn(false);
                        //     })
                        // })



                        var formData = new FormData();

                        userDocs.pictures.map((userDoc, index) => {

                            console.log(userDoc);

                            // // format file name
                            const guarantorName = `${values.firstname}-${values.phoneno}`;
                            const fileType = `${userDoc.fileObj.type}`;
                            const cleanFilename = `images/guarantors/${guarantorName.toLowerCase()}-${userDoc.fileObj.name.toLowerCase()}`;
                            formData.append(userDoc.fieldName, userDoc.fileObj, userDoc.fileObj.name);


                            const generatePutUrl = decodeURIComponent(`https://aws-file-uploader.herokuapp.com/generate-put-url?file-name=${cleanFilename}&file-type=${fileType}`);
                            
                            fetch(generatePutUrl, {
                                method: 'GET'
                            })
                            .then(response => response.json())
                            .then(data => {
                                console.log(data)
                                const putURL = data;
                                fetch(putURL, {
                                    method: 'PUT',
                                    body: userDoc.fileObj,
                                })
                                .then(res => {
    
                                    console.log(res);
                                    
                                    setDialogProps(prevState => {
    
                                        return {
                                            ...prevState,
                                            isOpen: true,
                                            fetchStatus: 'success',
                                            names: values.firstname+' '+values.lastname,
                                            summary: {},
                                            msg: 'Thanks for submitting your application.',
                                            handleClose
                                        }
                                    });
                                    setIsSubmitBtn(false);
                                })
                                .catch(err => {
    
                                    setDialogProps(prevState => {
    
                                        return {
                                            ...prevState,
                                            isOpen: true,
                                            fetchStatus: 'failed',
                                            names: values.firstname+' '+values.lastname,
                                            summary: {},
                                            msg: 'Seems like something went wrong, pls try again!',
                                            handleClose
                                        }
                                    });
                                    setIsSubmitBtn(false);
                                })

                            })
                            .catch(err => {
                                setDialogProps(prevState => {
    
                                    return {
                                        ...prevState,
                                        isOpen: true,
                                        fetchStatus: 'failed',
                                        names: values.firstname+' '+values.lastname,
                                        summary: {},
                                        msg: 'Seems like something went wrong, pls try again!',
                                        handleClose
                                    }
                                });
                                setIsSubmitBtn(false);
                            })
                        })
    
                        
                    }
                });
    
            }
        }
    })

    return (
        <div className="guarantor-form-container">
            <SubmitFormDialog dialogProps={dialogProps} />
            {/* <UploadFileDialog uploadDialogProps={uploadDialogProps} /> */}
            <div className="guarantor-form-container-flex">
                <div className="guarantor-form-container-item">
                    <div className="guarantor-form-header-body-cover-flex">
                        <div className="guarantor-form-header-body-cover-item">
                            <div className="guarantor-form-header-cover">
                                <div className="company-logo-header-cover">
                                    <div className="logo-header-cover-flex">
                                        <div className="logo-header-cover-item">
                                            <div className="image-cover-flex">
                                                <div className="image-cover-item">
                                                    <img className="header-logo-img" src="/assets/images/mkobo-logo.png" alt="mkobo image" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="logo-header-cover-item">
                                            <div className="image-cover-flex">
                                                <div className="image-cover-item">
                                                    <img className="header-logo-img" src="/assets/images/etransact-logo.png" alt="etransact image" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="guarantor-form-header">
                                    <h2 className="guarantor-form-header-title">LIFELINE AWC GUARANTOR FORM</h2>
                                </div>
                            </div>
                            <div className="guarantor-form-body-cover">
                                <div className="guarantor-form-body">
                                    <p className="guarantor-form-body-text">The Guarantor should understand the full implication of guarantor-ship or seek legal advice before signing this form.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-container">
                        <form className={`${classes.formRoot} form-tag-cover`} id="guarantor-form-tag-cover" encType="multipart/form-data" ref={formTagRef} onSubmit={formik.handleSubmit}>
                            <div className="agent-details-cover">
                                <div className="agent-details-cover-header">
                                    <h2 className="header-title">Agent's Details</h2>
                                </div>
                                <div className="personal-details-cover-body">
                                    <div className="personal-details-cover-body-item">
                                        <div className="textfield-cover">
                                            <div className="name-acct-cover-flex">
                                                <div className="name-acct-cover-item">
                                                    <TextField className="textfield-input-short" name="agentFullname" id="agent-fullname-short" label="Agent Fullname" fullWidth value={formik.values.agentFullname} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                </div>
                                                <div className="name-acct-cover-item">
                                                    <TextField className="textfield-input-short" name="pocketmoniAcct" id="pocketmoni-acct-short" label="Pocketmoni Account" type="number" fullWidth value={formik.values.pocketmoniAcct} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                    {formik.touched.pocketmoniAcct || formik.errors.pocketmoniAcct ? (
                                                        <div className="formik-error-div">{formik.errors.pocketmoniAcct}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="personal-details-cover">
                                <div className="personal-details-cover-header">
                                    <h2 className="header-title">Personal Details</h2>
                                </div>
                                <div className="personal-details-cover-body">
                                    <div className="personal-details-cover-body-item">
                                        <div className="textfield-cover">
                                            <div className="title-gender-cover-flex">
                                                <div className="title-gender-cover-item">
                                                    <FormControl className={`${classes.selectFormControl} select-form-control-cover`}>
                                                        <InputLabel id="title-select-label">Title</InputLabel>
                                                        <Select 
                                                            className="title-select-field"
                                                            labelId="title-select-label"
                                                            id="title-select"
                                                            value={formik.values.title}
                                                            onChange={formik.handleChange}
                                                            name="title"
                                                        >
                                                            <MenuItem value="Mr">Mr</MenuItem>
                                                            <MenuItem value="Mrs">Mrs</MenuItem>
                                                            <MenuItem value="Miss">Miss</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                                <div className="title-gender-cover-item">
                                                    <FormControl className={`${classes.selectFormControl} select-form-control-cover`}>
                                                        <InputLabel id="gender-select-label">Gender</InputLabel>
                                                        <Select 
                                                            className="gender-select-field"
                                                            labelId="gender-select-label"
                                                            id="gender-select"
                                                            value={formik.values.gender}
                                                            onChange={formik.handleChange}
                                                            name="gender"
                                                        >
                                                            <MenuItem value="Male">Male</MenuItem>
                                                            <MenuItem value="Female">Female</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                            <div className="name-cover-flex">
                                                <div className="name-cover-item">
                                                    <TextField className="textfield-input-short" name="firstname" id="firstname-short" label="Firstname" fullWidth value={formik.values.firstname} onBlur={formik.handleBlur} onChange={formik.handleChange} onInput={(e) => {
                                                        e.target.value = e.target.value.replace(/[^a-z]/g, "");
                                                    }} required />
                                                </div>
                                                <div className="name-cover-item">
                                                    <TextField className="textfield-input-short" name="lastname" id="lastname-short" label="Lastname" fullWidth value={formik.values.lastname} onBlur={formik.handleBlur} onChange={formik.handleChange} onInput={(e) => {
                                                        e.target.value = e.target.value.replace(/[^a-z]/g, "");
                                                    }} required />
                                                </div>
                                            </div>
                                            <div className="email-phoneno-cover-flex">
                                                <div className="email-phoneno-cover-item">
                                                    <TextField className="textfield-input-short" name="email" id="email-short" type="email" label="Email" fullWidth value={formik.values.email} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                    {formik.touched.email || formik.errors.email ? (
                                                        <div className="formik-error-div">{formik.errors.email}</div>
                                                    ) : null}
                                                </div>
                                                <div className="email-phoneno-cover-item">
                                                    <TextField className="textfield-input-short" name="phoneno" id="phoneno-long" label="Phone No" type="number" fullWidth value={formik.values.phoneno} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                    {formik.touched.phoneno || formik.errors.phoneno ? (
                                                        <div className="formik-error-div">{formik.errors.phoneno}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="address-cover">
                                                <TextField className="textfield-input-long" name="homeAddress" id="home-address-long" label="Home Address" multiline rowsMax="4" fullWidth value={formik.values.homeAddress} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                            </div>
                                            <div className="relationship-cover">
                                                <TextField className="textfield-input-long" name="relationship" id="relationship-long" label="Relationship" fullWidth value={formik.values.relationship} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                            </div>
                                            <div className="employment-cover">
                                                <FormControl className={`${classes.selectFormControl} select-form-control-cover`}>
                                                    <InputLabel id="employment-select-label">Employment</InputLabel>
                                                    <Select 
                                                        className="employment-select-field"
                                                        labelId="employment-select-label"
                                                        id="employment-select"
                                                        value={formik.values.employment}
                                                        onChange={formik.handleChange}
                                                        name="employment"
                                                    >
                                                        <MenuItem value="Employed">Employed</MenuItem>
                                                        <MenuItem value="Business owner">Business owner</MenuItem>
                                                    </Select>
                                                </FormControl> 
                                            </div>
                                            {
                                                formik.values.employment && formik.values.employment == 'Employed' ?
                                                <>
                                                    <div className="business-name-cover">
                                                        <TextField className="textfield-input-long" name="companyName" id="company-name-long" label="Company's Name" fullWidth value={formik.values.companyName} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                    </div>
                                                    <div className="business-address-cover">
                                                        <TextField className="textfield-input-long" name="companyAddress" id="company-address-long" label="Company's Address" multiline rowsMax="4" fullWidth value={formik.values.companyAddress} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                    </div>
                                                    <div className="business-activity-cover">
                                                        <FormControl className={`${classes.selectFormControl} form-control-cover`}>
                                                            <InputLabel id="business-activity-select-label">Business Activities</InputLabel>
                                                            <Select 
                                                                className="business-activity-select-field"
                                                                labelId="business-activity-select-label"
                                                                id="business-activity-select"
                                                                value={formik.values.businessActivity}
                                                                onChange={formik.handleChange}
                                                                fullWidth
                                                                name="businessActivity"
                                                            >
                                                                <MenuItem value="Advertising">Advertising</MenuItem>
                                                                <MenuItem value="Consulting">Consulting</MenuItem>
                                                                <MenuItem value="Hospitality">Hospitality</MenuItem>
                                                                <MenuItem value="Computer hardware and Software">computer hardware and software</MenuItem>
                                                                <MenuItem value="Construction and Real estate">construction and real estate</MenuItem>
                                                                <MenuItem value="Electrical Equipment and supplies">Electrical Equipment and supplies</MenuItem>
                                                                <MenuItem value="Electronic Component and supplies">Electronic Component and supplies</MenuItem>
                                                                <MenuItem value="Energy">Energy</MenuItem>
                                                                <MenuItem value="Environment">Environment</MenuItem>
                                                                <MenuItem value="Food and Beverage">Food and Beverage</MenuItem>
                                                                <MenuItem value="General Industrial Equipment">General Industrial Equipment</MenuItem>
                                                                <MenuItem value="Manufacturing and Processing">Manufacturing and Processing</MenuItem>
                                                                <MenuItem value="Printing and Publishing">Printing and Publishing</MenuItem>
                                                                <MenuItem value="Security and Protection">Security and Protection</MenuItem>
                                                                <MenuItem value="Transportation">Transportation</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                    <div className="job-title-cover">
                                                        <TextField className="textfield-input-long" name="jobTitle" id="job-title-long" label="Job Title" fullWidth value={formik.values.jobTitle} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                    </div>
                                                </>: null
                                            }
                                            {
                                                formik.values.employment && formik.values.employment == 'Business owner' ?
                                                <>
                                                    <div className="business-name-cover">
                                                        <TextField className="textfield-input-long" name="businessName" id="business-name-long" label="Business Name" fullWidth value={formik.values.businessName} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                    </div>
                                                    <div className="business-address-cover">
                                                        <TextField className="textfield-input-long" name="businessAddress" id="business-address-long" label="Business Address" multiline rowsMax="4" fullWidth value={formik.values.businessAddress} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                    </div>
                                                    {/* <div className="business-nature-cover">
                                                        <TextField className="textfield-input-long" name="businessNature" id="business-nature-long" label="Business Nature" fullWidth value={formik.values.businessNature} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                    </div> */}
                                                    <div className="business-activity-cover">
                                                        <FormControl className={`${classes.selectFormControl} form-control-cover`}>
                                                            <InputLabel id="business-activity-select-label">Business Activities</InputLabel>
                                                            <Select 
                                                                className="business-activity-select-field"
                                                                labelId="business-activity-select-label"
                                                                id="business-activity-select"
                                                                value={formik.values.businessActivity}
                                                                onChange={formik.handleChange}
                                                                fullWidth
                                                                name="businessActivity"
                                                            >
                                                                <MenuItem value="Advertising">Advertising</MenuItem>
                                                                <MenuItem value="Consulting">Consulting</MenuItem>
                                                                <MenuItem value="Hospitality">Hospitality</MenuItem>
                                                                <MenuItem value="Computer hardware and Software">computer hardware and software</MenuItem>
                                                                <MenuItem value="Construction and Real estate">construction and real estate</MenuItem>
                                                                <MenuItem value="Electrical Equipment and supplies">Electrical Equipment and supplies</MenuItem>
                                                                <MenuItem value="Electronic Component and supplies">Electronic Component and supplies</MenuItem>
                                                                <MenuItem value="Energy">Energy</MenuItem>
                                                                <MenuItem value="Environment">Environment</MenuItem>
                                                                <MenuItem value="Food and Beverage">Food and Beverage</MenuItem>
                                                                <MenuItem value="General Industrial Equipment">General Industrial Equipment</MenuItem>
                                                                <MenuItem value="Manufacturing and Processing">Manufacturing and Processing</MenuItem>
                                                                <MenuItem value="Printing and Publishing">Printing and Publishing</MenuItem>
                                                                <MenuItem value="Security and Protection">Security and Protection</MenuItem>
                                                                <MenuItem value="Transportation">Transportation</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                </>: null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="guarantor-covenant-details-cover">
                                <div className="guarantor-covenant-details-cover-header">
                                    <h2 className="header-title">THE GUARANTOR COVENANTS</h2>
                                </div>
                                <div className="guarantor-covenant-details-cover-body">
                                    <div className="guarantor-covenant-details-cover-body-item">
                                        <div className="guarantor-covenant-text">
                                            <span className="text-span">I</span>&nbsp;&nbsp;&nbsp;
                                            <span className="text-input-span"><TextField className="textfield-input-long" name="covenantFullname" id="covenant-fullname-long" placeholder="Guarantor's name" value={formik.values.firstname+' '+formik.values.lastname} onBlur={formik.handleBlur} onChange={formik.handleChange} required /></span>&nbsp;&nbsp;&nbsp;
                                            <span className="text-span">(Full Name of Guarantor) hereby guarantees absolutely and unconditionally the prompt payment when due, and at any time thereafter, of all indebtedness and obligations of every kind and nature of the named Agent to the bank, absolute or contingent, due or to become due, nowor hereafter existing (the “Indebtedness”), and in addition, the undersigned agrees to pay all expenses, including attorneys’ fees and legal expenses, paid or incurred by the bank to collectthe indebtedness, or any part thereof, and to enforce this guarantee.<br /><br /> The liability under this guaranty shall in no way be affected, by any compromise, waiver, settlement, change or modification to the loan agreement and I understand that such amendment and failure to be notified of same, shall not release me from my liability under this Guarantee. I hereby waive any presentment, protest and notice of dishonor or default, notice of acceptance of the guaranty, notice of extensions of credit or other actions taken in reliance hereon, and all demands and notices of any kind in connection with this guaranty or the Indebtedness.<br /><br /> In the event that the Agent fails to make good on any of his outstanding debt obligations, MKOBO Microfinance Bank Limited shall have recourse to me to settle the outstanding debt (principal and accrued interest) in a prompt manner. There shall be no obligation on the part of the Bank at any time to resort first for payment to the Borrower and the bank shall have the right to enforce this guarantee irrespective of whether or not proceedings or steps are being taken against any party primarily or secondarily liable on the Indebtedness.<br /><br /> By signing this agreement, the Guarantor agrees to be liable for the repayment of the bank loan <b>(principal + accrued interest)</b> in the event of the borrower's default.<br /><br /> I have carefully reviewed this contract and agree to and accept its terms and conditions. I am executing this Agreement as ofthe effective date first written above.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="guarantor-covenant-details-cover-footer">
                                <div className="footer-header-cover">
                                    <p className="footer-header-text">I agree to be bound by  the Loan Policy  of MKOBO Microfinance Bank Limited and agree to guarantee and be responsible  for  paying  the  entire  loan  amount  availed  to  the Agentin  the  event  of  a  default,  failing  which appropriate action (legal or otherwise) may be initiated against me.</p>
                                </div>
                                <div className="footer-header-input-cover">
                                    <div className="footer-header-input-cover-flex">
                                        <div className="footer-header-input-cover-item">
                                            <div className="footer-header-textfield-cover-flex">
                                                <div className="footer-header-textfield-cover-item">
                                                    <TextField className="textfield-input-long" name="footerGuarantorName" id="footer-guarantor-name-long" label="Guarantor's Name" fullWidth value={formik.values.firstname+' '+formik.values.lastname} onBlur={formik.handleBlur} onChange={formik.handleChange} inputProps={{
                                                        readOnly: true
                                                    }} required />
                                                </div>
                                                <div className="footer-header-textfield-cover-item">
                                                    <TextField className="textfield-input-long" name="footerGuarantorSign" id="footer-guarantor-sign-long" label="Guarantor's Signature" fullWidth value={formik.values.footerGuarantorSign} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                </div>
                                            </div>
                                            <div className="footer-header-checkbox-cover-flex">
                                                <div className="footer-header-checkbox-cover-item">
                                                    <FormControl component="fieldset" className="checkbox-form-control-cover">
                                                        <FormGroup aria-label="position" row>
                                                            <FormControlLabel
                                                                checked={isCovenantAgree ? isCovenantAgree: false}
                                                                value={isCovenantAgree}
                                                                control={<Checkbox color="primary" />}
                                                                label="I Agree"
                                                                labelPlacement="end"
                                                                name="covenantAgree"
                                                                onChange={handleCheckbox}
                                                            />
                                                        </FormGroup>
                                                    </FormControl>
                                                </div>
                                                <div className="footer-header-checkbox-cover-item">
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                        <KeyboardDatePicker
                                                            disableToolbar
                                                            variant="inline"
                                                            format="MM/dd/yyyy"
                                                            margin="normal"
                                                            id="date-picker-inline"
                                                            // label="Date picker inline"
                                                            name="applicationDate"
                                                            value={formik.values.applicationDate}
                                                            onChange={formik.handleChange}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                            fullWidth
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="guarantor-document-upload-cover">
                                <div className="guarantor-document-upload-header-cover">
                                    <h2 className="upload-header-text">GUARANTOR DOCUMENT UPLOAD</h2>
                                </div>
                                <div className="guarantor-document-upload-body-cover">
                                    <div className="guarantor-document-upload-body-cover-flex">
                                        <div className="guarantor-document-upload-body-cover-item">
                                            <div className="upload-btn-cover-flex">
                                                <div className="upload-btn-cover-item">
                                                    <div className="upload-label-cover">
                                                        <label className="upload-btn-cover-label" htmlFor="guarantor-identity-upload">
                                                            <input type="file" style={{visibility: 'hidden', width: '0px', height: '0px'}} id="guarantor-identity-upload" name="guarantorIdentityUpload" ref={identityFileRef} onChange={handleFileChange} />
                                                            <Button
                                                                variant="contained"
                                                                className={`${classes.guarantorIdBtn} agent-id-util-btn`}
                                                                color="primary"
                                                                startIcon={<CloudUploadIcon />}
                                                                onClick={() => identityFileRef.current.click()}
                                                                // href="https://driveuploader.com/upload/m853VjnliQ/"
                                                            >
                                                                UPLOAD IDENTITY CARD
                                                            </Button>
                                                        </label>
                                                        <div className="identity-file-display-container">
                                                            <div className="identity-file-display-cover">
                                                                <img className="identity-file-display-img" src={''} alt={''} ref={idDisplayRef} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="upload-btn-cover-item">
                                                    <div className="upload-label-cover">
                                                        <label className="upload-btn-cover-label" htmlFor="guarantor-utility-upload">
                                                            <input type="file" style={{visibility: 'hidden', width: '0px', height: '0px'}} id="guarantor-utility-upload" name="guarantorUtilityUpload" ref={utilityFileRef} onChange={handleFileChange} />
                                                            <Button
                                                                variant="contained"
                                                                className={`${classes.guarantorIdBtn} agent-id-util-btn`}
                                                                color="primary"
                                                                startIcon={<CloudUploadIcon />}
                                                                onClick={() => utilityFileRef.current.click()}
                                                                // href="https://driveuploader.com/upload/E5RaxseVJJ/"
                                                            >
                                                                UPLOAD UTILITY BILL
                                                            </Button>
                                                        </label>
                                                        <div className="utility-file-display-container">
                                                            <div className="utility-file-display-cover">
                                                                <img className="utility-file-display-img" src={''} alt={''} ref={utilDisplayRef} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="agree-print-submit-details-cover">
                                <div className="agree-print-submit-flex">
                                    <div className="agree-print-submit-item">
                                        <div className="agree-cover">
                                            <FormControl component="fieldset" className="checkbox-form-control-cover">
                                                <FormGroup aria-label="position" row>
                                                    <FormControlLabel
                                                        checked={isTermsAgree ? isTermsAgree: false}
                                                        value={isTermsAgree}
                                                        control={<Checkbox color="primary" />}
                                                        label="I have read and agreed to the terms and condition of this application, as well as the entire loan policy of MKOBO Micrfinance Bank Limited"
                                                        labelPlacement="end"
                                                        name="termsAgree"
                                                        onChange={handleCheckbox}
                                                        required
                                                    />
                                                </FormGroup>
                                            </FormControl>
                                        </div>
                                        <div className="print-submit-cover-flex">
                                            <div className="print-submit-cover-item">
                                                <div className="print-submit-btn-cover">
                                                    <Button
                                                        variant="contained"
                                                        color="default"
                                                        startIcon={<PrintIcon />}
                                                        className="print-submit-btn"
                                                        disabled
                                                    >
                                                        Print This Form
                                                    </Button>
                                                </div>
                                            </div>
                                            <div className="print-submit-cover-item">
                                                <div className="print-submit-btn-cover">
                                                    {
                                                        isBtnChecks.isTermsAgree && isBtnChecks.isCovenantAgree && isBtnChecks.guarantorIdentityUpload && isBtnChecks.guarantorUtilityUpload ? 

                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            startIcon={<SendIcon />}
                                                            className="print-submit-btn"
                                                            // onClick={() => console.log(formik.valuesidation)}
                                                            type="submit"
                                                            disabled={ isSubmitBtn ? true: false }
                                                        >
                                                            { isSubmitBtn ? (<i>...Processing</i>): 'Submit' }
                                                        </Button>:

                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            startIcon={<SendIcon />}
                                                            className="print-submit-btn"
                                                            // onClick={() => console.log(formik.valuesidation)}
                                                            type="submit"
                                                            disabled={true}
                                                            >
                                                            Submit
                                                        </Button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GuarantorForm;